<template>
  <Header
    ref="headerRef"
    type="INCOME_STATEMENT"
    :title="t('menus.Reports')"
    :show-regenerate-button="false"
    :updated-on="updatedTime ? t('common.updatedOn') + utils.dateFormatting(updatedTime) + ' UTC' : ''"
  />
  <ReportsMenus ref="ReportsMenusRef" type="INCOME_STATEMENT" :title="t('project.nav.incomeStatement')" />

  <GuideStep v-if="reportStore.entityDetail?.guideStep < 3" type="INCOME_STATEMENT" />

  <div v-else v-loading="loading" style="min-height: 65vh">
    <FinancialStatement
      financial-type="income-statement"
      :is-show-regenerated-info="ReportsMenusRef?.isShowRegeneratedInfo"
    />
  </div>
</template>
<script lang="ts" setup>
import utils from '@/lib/utils'
import { useI18n } from 'vue-i18n'
import Header from '../components/Header.vue'
import GuideStep from '../components/GuideStep.vue'
import ReportsMenus from '../../components/ReportsMenus.vue'
import { useReportStore } from '@/stores/modules/reports/index'
import FinancialStatement from '../components/FinancialStatement.vue'

const { t } = useI18n()
const reportStore = useReportStore()
const { loading } = storeToRefs(reportStore)
const headerRef = ref()
const ReportsMenusRef = ref()

const updatedTime = computed(() => {
  return reportStore.financialData.updatedOn
})
</script>
<style lang="scss" scoped></style>
